interface UpdateItem {
  time: string;
  tag: string;
  title: string;
  summary: string;
}

const updates: UpdateItem[] = [
  {
    time: '08:32',
    tag: '娱乐爆料',
    title: '某顶流男星被曝与新晋小花深夜同返公寓',
    summary: '网友爆料拍到某顶流男星与近期热播剧女主角深夜同返公寓，两人举止亲密，疑似恋情曝光。当事人团队暂未回应。',
  },
  {
    time: '09:15',
    tag: '网友爆料',
    title: '某综艺节目录制现场爆发激烈冲突',
    summary: '网友发帖称某卫视综艺节目录制现场，两位常驻嘉宾因游戏环节发生口角，一度导致录制中断。节目组表示将保留剪辑权。',
  },
  {
    time: '10:07',
    tag: '最新爆料',
    title: '知名网红被曝偷税漏税，金额或达千万级',
    summary: '多个信源交叉确认，某千万粉丝级别网红因税务问题被相关部门约谈，具体金额尚未公布，粉丝后援会已紧急发声。',
  },
  {
    time: '11:20',
    tag: '娱乐爆料',
    title: '某大制作电影拍摄现场爆出替身受伤事件',
    summary: '圈内人士透露，某投资过亿的电影在拍摄高危动作戏时替身演员意外受伤，剧组被指安全措施不到位，引发行业热议。',
  },
  {
    time: '12:45',
    tag: '网友爆料',
    title: '某知名主持人被指在后台耍大牌刁难工作人员',
    summary: '匿名工作人员爆料某老牌主持人在跨年晚会后台对化妆师和助理发脾气，现场多名工作人员证实此事。',
  },
  {
    time: '14:10',
    tag: '社会猛料',
    title: '某网红餐厅被曝使用过期食材，卫生状况堪忧',
    summary: '内部员工匿名投稿曝光某网红连锁餐厅后厨卫生状况，大量使用过期食材且篡改保质期标签，相关部门已介入调查。',
  },
  {
    time: '15:33',
    tag: '最新爆料',
    title: '某音乐选秀节目导师阵容大换血引粉丝不满',
    summary: '新一季选秀节目导师名单疑似泄露，多位原导师被替换，粉丝在社交媒体发起联名抗议，节目组尚未正式回应。',
  },
  {
    time: '16:58',
    tag: '娱乐爆料',
    title: '某对明星夫妻被曝已分居半年，离婚协议进行中',
    summary: '知情人士透露某对公认的模范明星夫妻实际上已分居半年有余，目前正在进行离婚协议谈判，双方团队保持沉默。',
  },
  {
    time: '18:22',
    tag: '网友爆料',
    title: '某游戏主播被曝私下买卖外挂并教唆粉丝使用',
    summary: '网友晒出聊天记录截图，指控某知名游戏主播私下向粉丝兜售游戏外挂程序，并详细指导使用方法，引发电竞圈震动。',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-4xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            最新动态
          </h2>
          <p className="text-sm text-foreground-500">
            实时追踪每日爆料吃瓜最新进展，全天滚动更新
          </p>
        </div>

        <div className="relative">
          <div className="absolute left-[19px] top-2 bottom-2 w-px bg-background-300/60 hidden md:block"></div>

          <div className="space-y-4">
            {updates.map((item, idx) => (
              <div key={idx} className="flex gap-4 md:gap-6">
                <div className="hidden md:flex flex-col items-center pt-1 flex-shrink-0">
                  <div className="w-[10px] h-[10px] rounded-full bg-accent-500 flex-shrink-0"></div>
                </div>
                <div className="flex-1 bg-background-100 rounded-lg border border-background-200/70 p-4 md:p-5">
                  <div className="flex items-center gap-3 mb-2 flex-wrap">
                    <span className="text-xs font-medium text-accent-600 whitespace-nowrap">
                      {item.time}
                    </span>
                    <span className="text-xs px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 whitespace-nowrap">
                      {item.tag}
                    </span>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-800 mb-1">
                    <strong>{item.title}</strong>
                  </h3>
                  <p className="text-xs text-foreground-500 leading-relaxed">
                    {item.summary}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}